import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ============================================================================
// pwa-links-client-mod -- 公开导航首页
//
// 路径：/pwa-links
// PWA 应用分类导航页面。
// ============================================================================
import * as React from 'react';
import { useClientServiceByTag } from '@hvsin/mod-client-runtime';
import { PwaLinkCard } from './pwa-link-card.js';
export function PwaLinksPage(props) {
    const { initialData } = props;
    const apiClient = useClientServiceByTag('pwaLinksApiClient');
    const [links, setLinks] = React.useState(initialData?.links?.data ?? []);
    const [categories, setCategories] = React.useState(initialData?.categories ?? []);
    const [activeCategory, setActiveCategory] = React.useState('');
    const [keyword, setKeyword] = React.useState('');
    const [loading, setLoading] = React.useState(!initialData);
    const [error, setError] = React.useState(null);
    const fetchLinks = React.useCallback(async (category, searchKeyword) => {
        setLoading(true);
        setError(null);
        try {
            const result = await apiClient.getPublicLinks({
                category: category || undefined,
                keyword: searchKeyword || undefined,
                pageSize: 100,
            });
            setLinks(result.data);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '加载失败');
            setLinks([]);
        }
        finally {
            setLoading(false);
        }
    }, []);
    // 加载分类
    React.useEffect(() => {
        if (!initialData) {
            fetchLinks('', '');
        }
        // 加载分类列表
        if (!initialData?.categories?.length) {
            apiClient.getCategories().then(setCategories).catch(() => { });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleCategoryChange = (category) => {
        const next = activeCategory === category ? '' : category;
        setActiveCategory(next);
        fetchLinks(next, keyword);
    };
    const handleSearch = (e) => {
        e.preventDefault();
        fetchLinks(activeCategory, keyword);
    };
    return (_jsxs("div", { style: { minHeight: '100vh', backgroundColor: '#f8fafc' }, children: [_jsxs("header", { style: {
                    backgroundColor: '#fff',
                    borderBottom: '1px solid #e5e7eb',
                    padding: '32px 24px',
                    textAlign: 'center',
                }, children: [_jsx("h1", { style: {
                            margin: '0 0 8px',
                            fontSize: 28,
                            fontWeight: 700,
                            color: '#111827',
                            letterSpacing: '-0.02em',
                        }, children: "\u5E94\u7528\u5BFC\u822A" }), _jsx("p", { style: { margin: '0 0 20px', fontSize: 15, color: '#6b7280' }, children: "\u53D1\u73B0\u548C\u6536\u85CF\u4F18\u8D28 PWA \u5E94\u7528" }), _jsx("form", { onSubmit: handleSearch, style: { maxWidth: 480, margin: '0 auto' }, children: _jsxs("div", { style: { display: 'flex', gap: 8 }, children: [_jsx("input", { type: "text", value: keyword, onChange: (e) => setKeyword(e.target.value), placeholder: "\u641C\u7D22\u5E94\u7528\u540D\u79F0\u3001\u6807\u7B7E...", style: {
                                        flex: 1,
                                        padding: '10px 16px',
                                        borderRadius: 10,
                                        border: '1px solid #d1d5db',
                                        backgroundColor: '#fff',
                                        fontSize: 14,
                                        outline: 'none',
                                    } }), _jsx("button", { type: "submit", style: {
                                        padding: '10px 20px',
                                        borderRadius: 10,
                                        border: 'none',
                                        backgroundColor: '#4f46e5',
                                        color: '#fff',
                                        fontSize: 14,
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                    }, children: "\u641C\u7D22" })] }) })] }), categories.length > 0 && (_jsx("div", { style: {
                    maxWidth: 960,
                    margin: '0 auto',
                    padding: '16px 24px 0',
                }, children: _jsxs("div", { style: { display: 'flex', gap: 8, flexWrap: 'wrap' }, children: [_jsx("button", { onClick: () => handleCategoryChange(''), style: {
                                padding: '6px 14px',
                                borderRadius: 999,
                                border: '1px solid',
                                borderColor: activeCategory === '' ? '#4f46e5' : '#e5e7eb',
                                backgroundColor: activeCategory === '' ? '#eef2ff' : '#fff',
                                color: activeCategory === '' ? '#4f46e5' : '#6b7280',
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: 'pointer',
                            }, children: "\u5168\u90E8" }), categories.map(cat => (_jsx("button", { onClick: () => handleCategoryChange(cat.slug), style: {
                                padding: '6px 14px',
                                borderRadius: 999,
                                border: '1px solid',
                                borderColor: activeCategory === cat.slug ? '#4f46e5' : '#e5e7eb',
                                backgroundColor: activeCategory === cat.slug ? '#eef2ff' : '#fff',
                                color: activeCategory === cat.slug ? '#4f46e5' : '#6b7280',
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: 'pointer',
                            }, children: cat.name }, cat.slug)))] }) })), _jsxs("main", { style: { maxWidth: 960, margin: '0 auto', padding: '24px' }, children: [loading && (_jsx("div", { style: { padding: '60px 0', textAlign: 'center', color: '#9ca3af' }, children: "\u52A0\u8F7D\u4E2D..." })), error && (_jsx("div", { style: {
                            padding: 16,
                            backgroundColor: '#fef2f2',
                            border: '1px solid #fecaca',
                            borderRadius: 12,
                            color: '#dc2626',
                            fontSize: 14,
                        }, children: error })), !loading && !error && links.length === 0 && (_jsx("div", { style: { padding: '60px 0', textAlign: 'center', color: '#9ca3af' }, children: _jsx("p", { style: { fontSize: 16 }, children: keyword || activeCategory ? '未找到匹配的应用' : '暂无应用导航' }) })), !loading && !error && links.length > 0 && (_jsx("div", { style: { display: 'flex', flexDirection: 'column', gap: 12 }, children: links.map(link => (_jsx(PwaLinkCard, { link: link }, link._id))) }))] })] }));
}
//# sourceMappingURL=pwa-links-page.js.map